<template>
  <div>
    <div class="basket-item-wrapper">
      <div class="photo">
        <picture>
          <source
            v-if="object.item.photos[0]"
            :srcset="object.item.photos[0].url"
            :alt="object.displayname"
          />
          <source
            type="image/webp"
            srcset="../../assets/photo-holder.webp"
            :alt="object.displayname"
          />
          <img src="../../assets/photo-holder.png" :alt="object.displayname" />
        </picture>
      </div>
      <div class="details">
        <div>
          <router-link
            v-if="object.item.urlcomponent"
            :to="`/${object.item.urlcomponent}`"
            target="_blank"
            >{{ object.displayname }}</router-link
          >
          <span v-else>{{ object.displayname }}</span>
          <p>
            {{
              $t("COMMON.PRICE", {
                price: object.grossprice,
                currency: symbol
              })
            }}
          </p>
        </div>
        <div>
          <b-input-group v-if="object.item.urlcomponent" class="group">
            <div class="prepend">{{ $t("COMMON.QTY") }}</div>
            <b-form-input
              v-model="object.quantity"
              type="number"
              min="1"
              :disabled="isLoading"
              @change="updateQuantity"
            />
          </b-input-group>
        </div>
        <div>
          <b-btn
            v-if="object.item.urlcomponent"
            :disabled="isLoading"
            class="button"
            @click="remove"
            >{{ $t("COMMON.REMOVE") }}</b-btn
          >
        </div>
        <div class="additional-services">
          <div
            v-for="(service, index) in object.additionalservice"
            :key="index"
          >
            <p>{{ service.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import _ from "lodash";
import axios3C from "../../axios";

export default {
  name: "BasketItemComponent",
  data() {
    return {
      isLoading: false,
      axios3C
    };
  },
  methods: {
    updateQuantity: _.debounce(function() {
      this.isLoading = true;
      this.$emit("deletingStart");
      this.axios3C
        .post("/cart", {
          action: "updateCart",
          cart_id: this.cartId,
          line_id: this.object._id,
          field: "quantity",
          value: this.object.quantity,
          customer: "guest"
        })
        .then(res => {
          this.$emit("delete", res.data);
          this.$store.commit("updateQuantity", res.data.summary.quantity);
        })
        .catch(err => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.$emit("deletingStop");
          this.isLoading = false;
        });
    }, 500),
    remove() {
      this.isLoading = true;
      this.$emit("deletingStart");
      this.axios3C
        .post("/cart", {
          action: "updateCart",
          cart_id: this.cartId,
          line_id: this.object._id,
          field: "deleted",
          value: true,
          customer: "guest"
        })
        .then(res => {
          this.$emit("delete", res.data);
          this.$store.commit("updateQuantity", res.data.summary.quantity);
        })
        .catch(err => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.$emit("deletingStop");
          this.isLoading = false;
        });
    }
  },
  props: {
    object: Object,
    config: Object,
    cartId: String,
    symbol: String
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.basket-item-wrapper {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-column-gap: 20px;

  @media screen and (max-width: 960px) {
    grid-template-columns: auto;
    text-align: center;
  }

  .additional-services {
    color: #707070;
  }

  .details {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-column-gap: 10px;

    @media screen and (max-width: 960px) {
      grid-template-columns: auto;
      text-align: center;
    }

    .deliver-group {
      margin-top: 20px;
      font-size: 0.8em;
    }

    .group {
      width: 200px;

      @media screen and (max-width: 960px) {
        width: 80%;
        margin: 0 auto;
        margin-bottom: 20px;
      }
    }

    input {
      height: 40px;
      width: 100px;
    }

    .prepend {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      padding: 0 20px;
      background-color: #e9ecef;
      border-top: 1px solid #ced4da;
      border-left: 1px solid #ced4da;
      border-bottom: 1px solid #ced4da;
    }
  }

  .photo {
    img {
      height: 150px;
      width: 100%;
      object-fit: contain;
      border: 1px solid #ced4da;
    }
  }

  .remove {
    text-align: right;

    @media screen and (max-width: 960px) {
      text-align: center;
    }
    .button {
      background-color: black;
      text-transform: uppercase;
    }
  }
}
</style>

<style lang="scss">
.air-freight {
  label {
    line-height: 20px;
  }
}
</style>
